var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "text-muted mb-1" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                "Estes valores valem para todos os dias da semana, exceto nos dias que você personalizar na outra aba."
              )
            ) +
            " "
        ),
      ]),
      _c(
        "b-row",
        [
          !_vm.hideActivation
            ? _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "delivery-config-default-enabled",
                      type: "switch",
                      name: "defaultDeliveryEnabled",
                      label: _vm.$t("Delivery habilitado"),
                    },
                    model: {
                      value: _vm.config.defaultDeliveryEnabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "defaultDeliveryEnabled", $$v)
                      },
                      expression: "config.defaultDeliveryEnabled",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.hideActivation
            ? _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "delivery-config-active",
                      type: "switch",
                      name: "active",
                      label: _vm.$t("Configuração ativa"),
                    },
                    model: {
                      value: _vm.config.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.config, "active", $$v)
                      },
                      expression: "config.active",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "delivery-config-default-min-order",
                  type: "text-number",
                  filter: "currency",
                  currency: "R$",
                  precision: 2,
                  name: "defaultMinOrderValue",
                  label: _vm.$t("Valor mínimo de pedido"),
                },
                model: {
                  value: _vm.config.defaultMinOrderValue,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "defaultMinOrderValue", $$v)
                  },
                  expression: "config.defaultMinOrderValue",
                },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { md: "3" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "delivery-config-default-fee-per-km",
                  type: "text-number",
                  filter: "currency",
                  currency: "R$",
                  precision: 2,
                  name: "defaultDeliveryFeePerKilometer",
                  label: _vm.$t("Taxa por KM"),
                  instruction: _vm.$t(
                    "Usada nos pedidos do ERP cobrados por quilômetro. Os pedidos com taxa única e o online usam as faixas abaixo."
                  ),
                },
                model: {
                  value: _vm.config.defaultDeliveryFeePerKilometer,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "defaultDeliveryFeePerKilometer", $$v)
                  },
                  expression: "config.defaultDeliveryFeePerKilometer",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("hr"),
      _c("h5", [_vm._v(_vm._s(_vm.$t("Faixas de taxa de entrega")))]),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                "A taxa é definida por faixas conforme o valor do pedido. Ex.: a partir de R$ 0,00 cobra R$ 8,00; a partir de R$ 80,00 fica grátis. Dias sem faixas próprias usam estas."
              )
            ) +
            " "
        ),
      ]),
      _c("delivery-fee-tiers", {
        attrs: {
          tiers: _vm.config.defaultTiers,
          name: "defaultTiers",
          label: _vm.$t("Faixas de taxa"),
        },
      }),
      _c("hr"),
      _c("h5", [_vm._v(_vm._s(_vm.$t("Grupos isentos da base de cálculo")))]),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t(
                'Produtos destes grupos não entram no valor usado para escolher a faixa de taxa. Ex.: excluir "Chopes" faz um pedido de R$ 200 com R$ 150 em chope contar apenas R$ 50 para a faixa.'
              )
            ) +
            " "
        ),
      ]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { md: "8" } },
            [
              _c("FormulateInput", {
                attrs: {
                  id: "delivery-config-excluded-groups",
                  type: "vue-select",
                  name: "excludedGroupIds",
                  label: _vm.$t("Grupos excluídos da taxa"),
                  options: _vm.groupOptions,
                  multiple: true,
                  placeholder: _vm.$t("Selecione os grupos (opcional)"),
                },
                model: {
                  value: _vm.config.excludedGroupIds,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "excludedGroupIds", $$v)
                  },
                  expression: "config.excludedGroupIds",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }